var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":this.to},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('li',{class:['nav-item', (isActive &&isExactActive) && 'active']},[_c('a',{staticClass:"nav-link",attrs:{"href":href},on:{"click":navigate}},[_vm._v(_vm._s(_vm.name))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }